const styles = {
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 20,
  },
  subTitle: {
    fontSize: 17,
    fontWeight: 500,
    lineHeight: '141%',
    marginBottom: 20,
  },
  button: {
    width: 80,
    height: 40,
    fontSize: 15,
    fontWeight: 600,
    margin: '0px 4px',
  },
  form: {
    input: {
      large: {
        width: 175,
        marginRight: 8,
      },
      medium: {
        width: 100,
        marginRight: 8,
      },
    },
    button: {
      marginRight: 8,
    },
    date: {
      width: 120,
    },
    text: {
      fontSize: 13,
      fontWeight: 400,
    },
  },
  linkButton: {
    border: 'none',
    background: 'none',
    fontSize: 12,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
};

export default styles;